// What the `?` overlay lists. It is built from the same keys shortcuts.ts
// dispatches on, in the order the Author would learn them, so the overlay
// cannot promise a key the handler does not answer.

import { useTranslation } from "react-i18next";
import type { ShortcutGroup } from "../../../components/overlay/ShortcutsOverlay";

/** Command on macOS, Control elsewhere; the commit chord accepts either. */
const commitKey = (): string =>
  typeof navigator !== "undefined" && /Mac|iP(hone|ad|od)/.test(navigator.platform) ? "⌘" : "Ctrl";

/**
 * A hook rather than a function taking `t`: the reference scanner reads the
 * namespace from the `useTranslation()` that binds `t` in the same scope, and
 * a `t` arriving as a parameter would be checked against the wrong catalogue.
 */
export function useShortcutGroups(): ShortcutGroup[] {
  const { t } = useTranslation("review");
  return [
    {
      title: t("shortcuts.reading"),
      items: [
        { keys: ["j"], label: t("shortcuts.next") },
        { keys: ["k"], label: t("shortcuts.previous") },
        { keys: ["1"], label: t("view.sideBySide") },
        { keys: ["2"], label: t("view.inline") },
        { keys: ["3"], label: t("view.scriptOnly") },
        { keys: ["p"], label: t("shortcuts.play") },
      ],
    },
    {
      title: t("shortcuts.editing"),
      items: [
        { keys: ["e"], label: t("shortcuts.edit") },
        { keys: [commitKey(), "Enter"], label: t("shortcuts.commit") },
        { keys: ["Esc"], label: t("shortcuts.cancel") },
      ],
    },
    {
      title: t("shortcuts.chapter"),
      items: [
        { keys: ["a"], label: t("shortcuts.approve") },
        { keys: ["r"], label: t("shortcuts.instruction") },
      ],
    },
  ];
}
